// 099 D13 站点健康：未接入诚实态（无 Sentry/Cloudflare 数据源时不编造）
import { ops } from "../../lib/api";
import { useOpsQuery } from "./useOpsQuery";
import { Note } from "./widgets";

export default function SiteHealth() {
  const q = useOpsQuery(() => ops.siteHealth(), []);

  if (q.loading && !q.data) return <p className="muted">加载中…</p>;
  if (q.forbidden) return <p>🔒 {q.forbidden}</p>;
  if (q.error) return <p style={{ color: "var(--err)" }}>加载失败：{q.error}</p>;
  if (!q.data) return null;
  const d = q.data;

  return (
    <>
      <h2 className="d-title">站点可用性与前端 / API 健康</h2>
      <p className="d-sub2">与「生成与成本」互补：生成任务正常 ≠ 站点正常</p>

      {!d.configured && (
        <div className="d-alert">
          ⚠ <span><b>未接入站点健康监控。</b>{d.note}</span>
        </div>
      )}

      <div className="d-grid d-kpis" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))" }}>
        <div className="d-card d-kpi"><div className="k">前端 JS 错误率</div><div className="v na">未接入</div><div className="d flat">Sentry 类来源未配置</div></div>
        <div className="d-card d-kpi"><div className="k">API 5xx 占比</div><div className="v na">未接入</div><div className="d flat">Cloudflare 指标未配置</div></div>
        <div className="d-card d-kpi"><div className="k">LCP / CLS / INP</div><div className="v na">未接入</div><div className="d flat">Web Vitals 采集未配置</div></div>
        <div className="d-card d-kpi"><div className="k">dashboard 自身监控</div><div className="v na">未接入</div><div className="d flat">接入后须覆盖本后台自身</div></div>
      </div>

      <Note>
        接入时的隐私约束（D04⑤ 同款）：监控载荷不含邮箱、输入原文、项目内容、签名 URL；采样率与保留期在实施时确定。
        本页以「未接入」诚实展示，绝不用生成任务正常代替站点可用性结论。
      </Note>
    </>
  );
}
